import { render, staticRenderFns } from "./coderProDemographics.vue?vue&type=template&id=ea391b22&scoped=true&"
import script from "./coderProDemographics.vue?vue&type=script&lang=js&"
export * from "./coderProDemographics.vue?vue&type=script&lang=js&"
import style0 from "./coderProDemographics.vue?vue&type=style&index=0&id=ea391b22&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea391b22",
  null
  
)

export default component.exports